import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {AlertController, IonContent, ModalController} from '@ionic/angular';
import {NewDocumentService} from '../../../services/new-document.service';
import {LokijsService} from '../../../services/database/lokijs.service';
import {ValidateDocumentService} from '../../../services/validate-document.service';
import {SiteModel} from '../../../models/site.model';
import {GeneralService} from '../../../services/general.service';
import {MobileConfigurationModel} from '../../../models/mobile-configuration.model';
import {DocumentModel} from '../../../models/document.model';
import {GeneralSaveDocumentService} from '../../../services/general-save-document.service';
import {ContactModel} from '../../../models/contact.model';
import {StateManagerService} from '../../../services/state-manager.service';
import {CollectionsNames} from '../../../definitions/collections-names';

@Component({
    selector: 'app-orders',
    templateUrl: './orders.health-care.html',
    styleUrls: ['./orders.health-care.scss'],
})
export class OrdersHealthCare implements OnInit {

    @ViewChild('content') content: IonContent;
    @Input() document: DocumentModel;
    documentTemp: DocumentModel;
    mobileConfig: MobileConfigurationModel;

    constructor(private modalController: ModalController,
                private newDocumentService: NewDocumentService,
                private generalServices: GeneralService,
                private loki: LokijsService,
                private alertController: AlertController,
                private validateDoc: ValidateDocumentService,
                private generalSaveDocument: GeneralSaveDocumentService,
                private stateManager: StateManagerService,
                private collectionNames: CollectionsNames) {
    }

    ngOnInit() {
        this.documentTemp = JSON.parse(JSON.stringify(this.document));
        this.mobileConfig = this.stateManager.getCollection(this.collectionNames.MOBILECONFIGURATION);
    }

    listenCustomer(event) {
        this.documentTemp.customer = event;
        this.documentTemp.contact = new ContactModel();
        this.documentTemp.sigContact = new ContactModel();
        this.documentTemp.site = new SiteModel();
        this.documentTemp.signatureContact = null;
    }

    saveOrder() {
        if (!this.validateDoc.isValid(this.documentTemp)) {
            return;
        } else {
            this.document = JSON.parse(JSON.stringify(this.documentTemp));
            this.generalSaveDocument.generalSaveDocument(this.document);
        }
    }

    async cancelOrder() {
        if (JSON.stringify((this.document)) !== JSON.stringify(this.documentTemp)) {
            const alert = await this.alertController.create({
                message: 'Do you want to cancel the Order?',
                backdropDismiss: false,
                buttons: [
                    {
                        text: 'No',
                        role: 'cancel',
                        cssClass: 'secondary',
                        handler: () => {
                        }
                    }, {
                        text: 'Yes',
                        handler: () => {
                            this.modalController.dismiss();
                        }
                    }
                ]
            });
            await alert.present();
        } else {
            this.modalController.dismiss();
        }
    }
}
